import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormContext } from 'contexts';

import {
  AuFormItemWrapper,
  AuDirectionLink
} from 'components/DTA';
import ApplicationSuccessful from './ApplicationSuccessful';
import { urlSelector } from 'PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from 'components/Portal/Utilities';
interface FinalArnStepProps {
  successful: boolean;
  arnType: string;
  arnPath: string;
};
interface UserDetails { userdetails: unknown; };

const FinalArnStep: React.FC<FinalArnStepProps> = (props: FinalArnStepProps) => {
  const userdetails = useSelector((state: UserDetails) => state.userdetails);
  const userDetailsValue: any = userdetails;
  const userEmail = userDetailsValue.items.value[0].emailaddress1;
  const B2CSettings = useSelector((state: any) => state.B2CSettings);
  const urlHome = useSelector((state: any) => urlSelector(state, 'Portal - Home URL'));
  const { formAlert } = useContext(FormContext);

  const handleBackToDashBoard = () => {
    if (formAlert && formAlert[0] && formAlert[0].as === 'success') {
      sessionStorage.setItem('casa.indarnsCount', '1');
    }
    const dashboardUrl = getPortalUrl('/dashind', false, urlHome);
    window.location.href = dashboardUrl;
  };

  return (
    <>
      {
        formAlert &&
        formAlert[0] &&
        formAlert[0].as === 'success' &&
        <ApplicationSuccessful arnPath={props.arnPath} userEmail={userEmail} arnType={props.arnType} />
      }
      <AuFormItemWrapper>
        <AuDirectionLink onClick={handleBackToDashBoard} text="Return to myCASA" direction="left" />
      </AuFormItemWrapper>
    </>
  );

};

export default FinalArnStep;